import type { JSX } from 'react';

export type TTabConfig = {
  tabId: ETabId;
  tabName: string;
  component: JSX.Element;
  show: boolean;
  isNew?: boolean;
};

export enum ETabId {
  Global = 'SellerExperience',
  MyTeamTab = 'MyTeamTab',
  PerformanceTab = 'PerformanceTab',
  EarningsTab = 'EarningsTab',
  ImpersonationTab = 'ImpersonationTab',
  PlanSetupTab = 'PlanSetupTab',
  ComplianceTab = 'ComplianceTab',
  PlanSummaryTab = 'PlanSummaryTab',
  MyChangeHistoryTab = 'MyChangeHistoryTab',
  EstimatorTab = 'EstimatorTab',
  NotificationsAdminTab = 'NotificationsAdminTab',
  MyCompensationTab = 'MyCompensationTab',
  MyPlanTab = 'MyPlanTab',
}
